import { isSwanConsent } from '~/utils/consents';
import { useVisibleBankingConsents } from './useVisibleBankingConsents';

export const useVisibleSwanConsent = () => {
  const { visibleConsents } = useVisibleBankingConsents();
  return visibleConsents.find(isSwanConsent);
};
